import React from 'react';

const STATUS_CONFIG = {
  PENDING:      { label: 'Pending',      cls: 'chip-pending' },
  CODED:        { label: 'Coded',        cls: 'chip-coded' },
  SUBMITTED:    { label: 'Submitted',    cls: 'chip-submitted' },
  APPROVED:     { label: 'Approved',     cls: 'chip-approved' },
  REJECTED:     { label: 'Rejected',     cls: 'chip-rejected' },
  NEEDS_REVIEW: { label: 'Needs Review', cls: 'chip-needs_review' },
  LOCKED:       { label: 'Locked',       cls: 'chip-locked' },
  EXPORTED:     { label: 'Exported',     cls: 'chip-exported' },
  OPEN:         { label: 'Open',         cls: 'chip-open' },
  ACTIVE:       { label: 'Active',       cls: 'chip-active' },
  STAGED:       { label: 'Staged',       cls: 'chip-staged' },
  PROMOTED:     { label: 'Promoted',     cls: 'chip-promoted' },
};

export function StatusChip({ status, size = 'sm' }) {
  const cfg = STATUS_CONFIG[status] || { label: status, cls: 'chip-pending' };
  const px = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${px} ${cfg.cls}`}
      aria-label={cfg.label}
    >
      {cfg.label}
    </span>
  );
}
